import { render, staticRenderFns } from "./Map.global.vue?vue&type=template&id=52058532&scoped=true&lang=pug&"
import script from "./Map.global.vue?vue&type=script&lang=ts&"
export * from "./Map.global.vue?vue&type=script&lang=ts&"
import style0 from "./Map.global.vue?vue&type=style&index=0&id=52058532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52058532",
  null
  
)

export default component.exports